<template>
	<section ref="faqWrapper" :class="['faq-wrapper', {
		iframe: iframe.active
	}]">
		<header v-if="categories && currentCategory" :class="['faq-header', {
			'uses-dropdown' : usingCategoryDropdown
		}]">
			<IframeTopBar 
				v-if="iframe.active" 
				:settings="iframe.header" 
				:activePage="pageSlug" 
				v-on:showPage="showPage" 
				v-on:showQuestionForm="showQuestionForm" />
			<h2 v-if="!isPageMode && iframe.active">Velg standard</h2>
			<Categories 
				v-if="!isPageMode" 
				:isMobile="isMobile" 
				:isIframe="iframe.active" 
				:currentCategory="currentCategory" 
				:categories="categories" 
				v-on:switchCategory="switchCategory" />
			<figure v-if="!isPageMode && currentCategory && currentCategory.image && !iframe.active" class="faq-category-image">
				<a v-if="currentCategory.image.link" :href="currentCategory.image.link">
					<img :src="currentCategory.image.src" alt="currentCategory.image.alt" />
				</a>
				<img v-if="!currentCategory.image.link" :src="currentCategory.image.src" alt="currentCategory.image.alt" />
			</figure>
		</header>
		<section v-if="!isPageMode" class="faq-questions-wrapper">
			<div v-if="currentCategory" class="questions-header">
				<h2 v-if="!iframe.active">{{ currentCategory.name }}</h2>
				<div 
					v-if="iframe.active && currentCategory" 
					class="iframe-only-featured-content">
						<IframeLinks 
							v-if="typeof iframe.links !== 'undefined' && typeof iframe.links[currentCategory.slug] !== 'undefined'"
							:links="iframe.links[currentCategory.slug]" 
							v-on:showPage="showPage" />
						<IframeAd 
							v-if="typeof iframe.ads !== 'undefined' && typeof iframe.ads[currentCategory.slug] !== 'undefined'"
							:ad="iframe.ads[currentCategory.slug]" />
				</div>
				<button 
					id="faq-filters-toggle" 
					aria-expanded="(filtersOpen) ? 'true' : 'false'" 
					aria-controls="faq-filters-form" 
					title="Filtrer"
					:class="['mobile-toggle-button', {
						hidden : !isMobile,
						active : filtersOpen
					}]" 
					@click.stop.prevent="filtersOpen = !filtersOpen">
					Filtrer
					<span :class="['dc-icon-circle', {
						'icon-minus' : filtersOpen,
						'icon-plus' : !filtersOpen
					}]">
						<span class="screen-reader-text">Les mer</span>
					</span>
				</button>
				<form 
					id="faq-filters-form"
					:class="['faq-form', {
						active : filtersOpen
					}]">
					<div class="field-wrapper text">
						<label for="s">Søk:</label>
						<input name="s" type="text" placeholder="Søk etter innhold" v-model="model.s" @change="newSearchTimeout" />
					</div>
					<div class="field-wrapper text">
						<label for="id">Søk ID:</label>
						<input name="id" type="text" placeholder="Søk etter ID" v-model="model.id" @change="newSearchTimeout" />
					</div>
					<div class="field-wrapper select">
						<label for="sort">Sorter på:</label>
						<select 
							name="sort" 
							v-model="model.sort" 
							@change="newSearchTimeout">
							<option value="">Sorter etter</option>
							<option value="date">Dato</option>
							<option value="subject">Emne</option>
							<option value="avsnitt">Avsnitt</option>
							<option value="unique-id">Unik ID</option>
						</select>
					</div>
				</Form>
			</div>
			<List 
				v-if="questions" 
				:questions="questions" 
				:preselectedVariant = "settings.initial_variant"
				:loading="loading" 
				:endpoint="settings.question_endpoint" />
			<div v-if="loading && !questions" 
			:class="['dc-icon-circle', 'loading', 'standards-loading']">
				<span class="dot"></span>
				<span class="dot"></span>
				<span class="dot"></span>
				<span class="screen-reader-text">Laster ned</span>
			</div>
			<button 
				id="nek-faq-load-more"
				v-if="canLoadMore" 
				class="dc-button dc-button--type-secondary"
				@click.stop.prevent="loadMore">{{ loadMoreLabel }}</button>
			<NoResults 
				v-if="!loading && questions.length===0" 
				:noResultsText="noResultsText" 
				v-on:showQuestionForm="showQuestionForm" />
		</section>
		<Page 
			v-if="isPageMode" 
			:endpoint="iframe.endpoints.page"
			:pageSlug="pageSlug" 
			v-on:closePage="showPage('')" />
		<Survey 
			v-if="iframe.active"
			:endpoint="iframe.endpoints.survey"
			:data="iframe.survey" />
	</section>
</template>

<script>
import IframeLinks from './parts/iframe/Links';
import IframeAd from './parts/iframe/Ad';
import IframeTopBar from './parts/iframe/TopBar';
import Categories from './parts/Categories';
import List from './parts/List';
import Page from './parts/Page';
import Survey from './parts/Survey';
import NoResults from './parts/NoResults';
export default {
	data() {
		return {
			loading: false,
			pageSlug: '',
			filtersOpen: false,
			isMobile: false,
			currentCategory: null,
			currentCategoryVariant: null,
			canLoadMore: false,
			model: {
				sort: '',
				id: '',
				s: '',
				paged: '',
			},
			questions: [],
			searchTimeout: null,
			isMobileTimeout: null,
		}
	},
	props: {
		categories: {
			type: Array,
			required: true,
			default: []
		},
		settings: {
			type: Object,
			required: true,
			default: {}
		},
		iframe: {
			type: Object,
			required: false,
		}
	},
	computed: {
		loadMoreLabel() {
			return (this.loading) ? 'Laster mer' : 'Last mer'
		},
		usingCategoryDropdown() {
			return (this.isMobile || this.iframe.active)
		},
		isPageMode() {
			return (this.iframe.active && this.pageSlug!=='')
		},
		noResultsText() {
			return (this.iframe.active) ? this.settings.text_no_results_web : this.settings.text_no_results_iframe
		}
	},
	methods: {
		showPage(slug) {
			this.pageSlug = slug;
		},
		showQuestionForm() {
			const questionForm = document.getElementById('faq-question-form');
			questionForm.classList.add('active')
			questionForm.ariaHidden = false;
            document.body.classList.add('overlay-active');
		},
		refreshQuery() {
			this.canLoadMore = false;
			this.model.paged = 1;
			this.questions = [];
		},
		switchCategory(category_id) {
			this.currentCategory = this.categories[category_id];
			this.updateUrl();
			this.doNewSearch();
		},
		doNewSearch() {
			this.refreshQuery();
			this.loadQuestions();
		},
		newSearchTimeout() {
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(this.doNewSearch(), 500);
		},
		updateUrl() {
			const nextUrl = (this.currentCategory===null) ? window.location.href : this.getUpdatedTabUrl(window.location.href, 'opentab', this.currentCategory.slug)
			window.history.replaceState('nekfaq', '', nextUrl);
		},
		getUpdatedTabUrl(uri, key, value) {
			var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
			var separator = uri.indexOf('?') !== -1 ? "&" : "?";
			if (uri.match(re)) {
				return uri.replace(re, '$1' + key + "=" + value + '$2');
			} else {
				return uri + separator + key + "=" + value;
			}
		},
		getQueryString() {
			let queryString = '';
			Object.keys(this.model).forEach((key) => {
				const value = this.model[key];
				if (value === '' || (key==='paged'&&value===1)) return '';
				queryString += (queryString === '') ? '?' : '&';
				queryString += (key + '=' + value);
			})
			return queryString;
		},
		loadQuestions() {
			this.loading = true;
			let endpointUrl = this.settings.search_endpoint + this.currentCategory.id + this.getQueryString();
			fetch(endpointUrl)
			.then(response => response.json())
			.then(data => {
				this.loading = false;
				this.canLoadMore = data.data.can_load_more;
				this.questions = this.questions.concat(data.data.results);
			});
		},
		loadMore() {
			this.model.paged = this.model.paged + 1;
			this.loadQuestions();
		},
		updateIsMobile() {
			clearTimeout(this.isMobileTimeout);
			this.isMobileTimeout = setTimeout(() => {
				this.isMobile = (window.innerWidth<639)
			}, 100)
		},
		setCurrentCategoryBySlug(slug) {
			for (const categoryId in this.categories) {
				if (this.categories[categoryId].slug!==slug) continue;
				this.currentCategory = this.categories[categoryId];
			}
		},
		checkMessageDomain(url) {
			const domain = url.replace(/^https?\:\/\//i, "").replace(/^www./, '');
			if (domain==='google.com') return false;
			const allowed = this.iframe.allowed_domains.includes(domain);
			if (!allowed) {
				console.log('Your domain has not been authorized for use with the embedded FAQ. Please contact NEK for questions.');
			}
			return allowed;
		},
		receiveMessage(event) {
			const eventName = event.data.faqEventName
			if (this.checkMessageDomain(event.origin)===true) {
				switch (eventName) {
					case 'search':
						this.setCurrentCategoryBySlug(event.data.cat);
						this.refreshQuery();
						this.model.s = event.data.s;
						this.model.sort = 'avsnitt';
						this.loadQuestions();
						break;
				}
			}
		}
	},
	mounted() {
		this.updateIsMobile();
		this.currentCategory = this.categories[this.settings.initial_category_id];
		this.currentCategoryVariant = this.settings.initial_variant;
		if (typeof this.settings.initial_results !== 'undefined' && this.settings.initial_results.total>0) {
			this.questions = this.settings.initial_results.results;
		} else {
			this.loadQuestions();
		}
		window.addEventListener('resize', this.updateIsMobile);
  		if (this.iframe.active) window.addEventListener('message', this.receiveMessage)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateIsMobile);
  		if (this.iframe.active) window.removeEventListener('message', this.receiveMessage)
	},
	watch: {
		currentCategory() {
			this.canLoadMore = false;
			this.model.paged = 1;
			this.question = []
		}
	},
	components: {
		IframeLinks,
		IframeAd,
		IframeTopBar,
		Categories,
		List,
		Page,
		Survey,
		NoResults,
	}
};
</script>
